module.exports = __webpack_public_path__ + "img/SocialHubLogoWhiteName.7b1d564e.png";